import {
  Controller
} from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const self = this
    event.preventDefault();
    const name = this.element.querySelector('#card-name').value;
    const email = this.element.querySelector('#card-email').value;
    const authenticity_token = document.querySelector('input[name="authenticity_token"]').value;
    const newInvitation = document.querySelector('#new_invitation');
    const submitSuccessWrap = document.querySelector('.submit-success-wrap');
    fetch(this.element.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          invitation: {
            name: name,
            email: email
          },
          authenticity_token: authenticity_token
        })
      })
      .then(response => {
        if (response.ok) {
          newInvitation.remove();
          submitSuccessWrap.classList.remove('d-none');

          // 送出後儲存cookie, 下次進入時不出現邀請函
          self.setCookie("tpefw_2026_invitation", "true", 7);
        } else {
          alert('There was an error submitting the form. Please try again.');
        }
      })
      .catch(() => {
        alert('There was an error submitting the form. Please try again.');
      });
  } // end submit

  // 送出後儲存cookie
  setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }
}